<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <!-- Card -->
        <!-- <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <div class="mb-2">
                  <span>Training Monitoring</span>
                 
                </div>

                <p class="text-muted mb-md-0">
                  This is Training Monitoring menu
                </p>
              </div>
            </div>
          </div>
        </div> -->
        <!-- My IDP dll -->
        <div class="card mt-5">
          <div class="card-header">
            <span class="mt-3 fs-2">IDP Management - Social Learning</span>
            <!-- <b-button
              v-if="currentTab === 1"
              class="btn btn-primary"
              variant="primary"
              v-b-modal.modal-training-aspiration>
              <span class="fe fe-plus-circle"></span>
              Add Training
            </b-button> -->
          </div>
          <div class="row px-4">
            <div class="col-6">
              <v-select
                :options="['Dummy 1', 'Dummy 2']"
                class="mt-4"
                placeholder="Filter by Bussiness Unit"></v-select>
            </div>
            <div class="col-6">
              <v-select
                :options="['Dummy 1', 'Dummy 2']"
                class="mt-4"
                placeholder="Filter by Employee Name"></v-select>
            </div>
            <div class="col-6">
              <v-select
                :options="['Dummy 1', 'Dummy 2']"
                class="mt-4"
                placeholder="Filter by Status"></v-select>
            </div>
          </div>
          <div class="table-responsive px-4">
            <div v-if="isLoading" class="text-center my-4">
              <span
                class="spinner-border"
                role="status"
                aria-hidden="true"></span>
              <p>Loading...</p>
            </div>

            <table
              v-else
              class="table table-sm table-bordered table-nowrap mt-4">
              <thead>
                <!-- {{inReview}} -->
                <tr class="">
                  <th rowspan="2">Employee Name</th>
                  <th rowspan="2">Coaching Title</th>
                  <th rowspan="2">Coaching Methodology</th>
                  <th rowspan="2"> Status</th>
                 
                  <!-- <th rowspan="2">Participants</th> -->
                  <th rowspan="2">Action</th>
                </tr>
              </thead>
              <tbody v-if="inReview && inReview.length">
                <tr v-for="(item, index) in inReview" :key="index">
                  <td class="">
                    {{ item.employee_name }}
                  </td>
                  <td class="">
                    {{ item.title }}
                  </td>
                  <td class="">
                    {{ item.methodology }}
                  </td>
                  <td class="text-center">
                    <h2>
                      <span :class="getBadgeStatus(item.status)">
                        <i
                              :class="getIconClass(item.status)"
                              class="me-1"></i>
                        {{ capitalizeStatus(item.status) }}
                      </span>
                    </h2>
                  </td>
                  <!-- <td class="text-center">
                    {{ item.participants ? item.participants.length : 0 }}
                  </td> -->
                  <td class="text-center">
                    <button
                      v-if="listTabMenu.privilages.update"
                      class="btn btn-sm btn-info mx-2"
                      @click="viewDetailsReview(item)">
                      <span class="fe fe-eye"></span>
                    </button>
                    <button
                      v-if="item.isl_status === 'completed'"
                      class="btn btn-sm btn-primary mx-2">
                      <span class="fe fe-download"></span>
                    </button>
                    <button
                      v-if="item.isl_status === 'completed'"
                      class="btn btn-sm btn-info mx-2">
                      <span class="fe fe-upload"></span>
                    </button>
                    <button
                      v-if="item.isl_status === 'submitted'"
                      class="btn btn-sm btn-primary mx-2"
                      @click="enrollTraining()">
                      <span class="fe fe-rotate-ccw"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="12">No Data Available</td>
                </tr>
              </tbody>
            </table>
            <!-- <table
              v-else
              class="table table-sm table-bordered table-nowrap mt-4">
              <thead>
                <tr class="">
                  <th rowspan="2">Competency</th>
                  <th rowspan="2">Coaching Title</th>
                 
                  <th rowspan="2">Participants</th>
                  <th rowspan="2">Action</th>
                </tr>
              </thead>
              <tbody v-if="structuredLearning && structuredLearning.length">
                <tr v-for="(item, index) in structuredLearning" :key="index">
                  <td class="">
                    {{ item.competency }}
                  </td>
                  <td class="">
                    {{ item.coaching_title }}
                  </td>
                  <td class="text-center">
                    {{ item.participants ? item.participants.length : 0 }}
                  </td>
                  <td class="text-center">
                    <button
                      class="btn btn-sm btn-info mx-2"
                      @click="viewDetails(item)">
                      <span class="fe fe-eye"></span>
                    </button>
                    <button
                      v-if="item.isl_status === 'completed'"
                      class="btn btn-sm btn-primary mx-2">
                      <span class="fe fe-download"></span>
                    </button>
                    <button
                      v-if="item.isl_status === 'completed'"
                      class="btn btn-sm btn-info mx-2">
                      <span class="fe fe-upload"></span>
                    </button>
                    <button
                      v-if="item.isl_status === 'submitted'"
                      class="btn btn-sm btn-primary mx-2"
                      @click="enrollTraining()">
                      <span class="fe fe-rotate-ccw"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="12">No Data Available</td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL HERE -->
     <!-- Modal Detail Review -->
    <b-modal
      v-model="isModalReview"
      title="Detail View"
      size="xl"
      hide-footer
      @hide="clearSelectedRow">
      <b-card>
        <b-card-body>
          <!-- {{ selectedRow }} -->
          <b-row>
            <b-col md="4">
              <b-card-title>Coaching Title</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.title
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4">
              <b-card-title>Coaching Methodology</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.methodology
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <!-- <b-col md="4">
              <b-card-title>Training Method</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_method
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
          </b-row>
          <!-- <b-row>
            <b-col md="4" class="mt-4">
              <b-card-title>Provider</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_provider
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4" class="mt-4">
              <b-card-title>Price</b-card-title>
              <b-card-text v-if="selectedRow">{{
                formatPrice(selectedRow.training_price)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row> -->
          <b-row md="4" class="mt-4" v-if="selectedRow">
            <b-col v-if="selectedRow.presentation_url">
              <b-card-title>Certificate</b-card-title>
              <img
                :src="selectedRow.presentation_url"
                :style="{ width: '300px', height: 'auto' }"
                alt="Certificate"
                class="img-fluid" />
              <!-- <b-button
                class="btn btn-primary"
                variant="primary"
                @click="downloadCertificate()">
                <span class="fe fe-download"></span>
                Download Certificate
              </b-button> -->
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            class="float-end"
            @click="completeReview(item)">
            <span class="fe fe-check-circle"></span> Complete
          </b-button>
          <!-- {{ selectedRow }} -->
        </b-card-body>
      </b-card>
    </b-modal>
    <!-- Modal Enroll -->
    <b-modal
      v-model="isEnrollModalVisible"
      title="Enroll Participants"
      size="lg"
      hide-footer
      @hide="clearEnrollModal">
      <!-- {{ selectedRow }} -->
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label class="form-label">Training Title</label>
            <input
              v-model="bodyEnroll.trainingTitle"
              type="text"
              class="form-control"
              placeholder="Training Title"
              disabled />
          </div>
          <!-- <div class="col-6">
            <label class="form-label">Training Provider</label>
            <input
              v-model="bodyEnroll.trainingProvider"
              type="text"
              class="form-control"
              placeholder="Training Provider"
              disabled />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyEnroll.trainingMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Price</label>
            <input
              v-model="bodyEnroll.price"
              type="number"
              class="form-control"
              placeholder="Price" />
          </div> -->
          <div class="col-12 mt-2">
            <label class="form-label">Location</label>
            <input
              v-model="bodyEnroll.location"
              type="text"
              class="form-control"
              placeholder="Location" />
          </div>
        </div>
        <div class="mt-4">
          <b-button @click="showScheduleModal" variant="primary"
            ><span class="fe fe-plus"></span>Add Schedule</b-button
          >
        </div>

        <!-- Schedule Table -->
        <div class="mt-4">
          <h4>Schedule</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th style="width: 50px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="scheduleList.length === 0">
                <td class="text-center" colspan="4">No Data Available</td>
              </tr>
              <tr v-else v-for="(item, index) in scheduleList" :key="index">
                <td>{{ item.date }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>
                  <button
                    @click="removeSchedule(index)"
                    class="btn btn-sm btn-danger">
                    <span class="fe fe-trash"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Participants Table -->
        <div class="mt-4">
          <h4>Participants</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="selectedParticipants.length === 0">
                <td class="text-center" colspan="2">No Data Available</td>
              </tr>
              <tr
                v-else
                v-for="(participant, index) in selectedParticipants"
                :key="index">
                <td>{{ participant.employee_name }}</td>
                <td>{{ participant.employee_position }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal Schedule -->
      <b-modal
        v-model="isScheduleModalVisible"
        title="Add Schedule"
        size="lg"
        hide-footer
        @hide="clearScheduleModal">
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <p class="form-label">Date</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select Date" />
            </div>
            <div class="col-6">
              <p class="form-label">Start Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.startTime"
                type="time"
                format="HH:mm"
                placeholder="Select Start Time" />
            </div>
            <div class="col-6 mt-4">
              <p class="form-label">End Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.endTime"
                type="time"
                format="HH:mm"
                placeholder="Select End Time" />
            </div>
          </div>
          <div class="mt-4">
            <b-button class="float-end" @click="addSchedule" variant="primary"
              >Add</b-button
            >
          </div>
        </div>
      </b-modal>
      <div class="mt-4 float-end">
        <b-button
          class="mr-3"
          @click="isEnrollModalVisible = false"
          variant="secondary"
          >Cancel</b-button
        >
        <b-button @click="submitEnroll" variant="primary"
          ><span class="fe fe-save mr-1"></span>Submit</b-button
        >
      </div>
    </b-modal>

    <!-- Modal Detail -->
    

    <!-- Modal Add Training -->
    <b-modal
      ref="modalTrainingAspiration"
      id="modal-training-aspiration"
      title="Buat Pelatihan Aspiration"
      hide-footer
      size="xl"
      centered>
      <div class="form-group">
        <div class="row">
          <!-- Bagian 1 -->
          <div class="col-6">
            <label class="form-label"
              >Competency
              <span class="text-danger"
                >(* Proficiency level is below standard)</span
              ></label
            >
            <v-select
              v-model="bodyAdd.competency"
              :options="dataCompetency"
              label="competency"
              :reduce="(e) => e.competency_id"
              placeholder="Select Competency" />
          </div>
          <div class="col-6">
            <label class="form-label">Provider</label>
            <v-select
              v-model="bodyAdd.provider"
              :options="dataProvider"
              label="name"
              @input="selectProvider"
              :reduce="(e) => e.id"
              placeholder="Select Provider" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Provider Name</label>
            <input
              v-model="bodyAdd.providerName"
              type="text"
              class="form-control"
              placeholder="Provider Name" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Address</label>
            <input
              type="text"
              v-model="bodyAdd.address"
              class="form-control"
              placeholder="Address" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              v-model="bodyAdd.websiteProvider"
              class="form-control"
              placeholder="Website" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Contact Person</label>
            <input
              type="text"
              v-model="bodyAdd.contactPerson"
              class="form-control"
              placeholder="Contact Person" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Email</label>
            <input
              type="text"
              v-model="bodyAdd.email"
              class="form-control"
              placeholder="Email" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Phone</label>
            <input
              type="number"
              class="form-control"
              v-model="bodyAdd.phone"
              placeholder="Phone" />
          </div>

          <!-- Bagian 2 -->
          <div class="col-6 mt-4">
             <label for="">Training
               <span class="text-danger"
                >(* Search Training If Exist)</span
              >
            </label>
            <v-select
              v-model="selectedLearning"
              :options="dataTraining"
              label="title"
              @input="selectTraining"
              @search="searchTraining"
              placeholder="Search Training">
              <!-- <span slot="no-options">Search Learning Title</span> -->
            </v-select>
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Name</label>
            <input
              type="text"
              class="form-control"
              v-model="bodyAdd.trainingName"
              placeholder="Training Name" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyAdd.learningMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Type</label>
            <v-select
              v-model="bodyAdd.learningType"
              :options="dataTrainingType"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Type" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Price</label>
            <div class="d-flex">
              <v-select
                style="width: 140px; color: gray"
                :options="currencies"
                v-model="bodyAdd.currency"
                class="mr-2" />
              <input
                v-model="bodyAdd.price"
                type="number"
                class="form-control"
                placeholder="Input Price (Numeric)" />
            </div>
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              class="form-control"
              v-model="bodyAdd.websiteTraining"
              placeholder="Website" />
          </div>
          <div class="col-12 mt-3">
            <label class="form-label">Description</label>
            <textarea
              v-model="bodyAdd.description"
              type="text"
              class="form-control"
              placeholder="Input Description" />
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="createTraining()"
        >Submit
      </b-button>
    </b-modal>
    <!-- Modal Confirmation -->
    <b-modal
      centered
      ref="confirmationModal"
      id="confirmation-modal"
      title="Submit Training"
      @ok="confirmSubmission">
      <div>
        <h5>Will be submitted:</h5>
        <ul v-if="approvedItems && approvedItems.length > 0">
          <li v-for="item in approvedItems" :key="item.id" class="text-success">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p>

        <h5>Will be rejected:</h5>
        <ul v-if="rejectedItems && rejectedItems.length > 0">
          <li v-for="item in rejectedItems" :key="item.id" class="text-danger">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be rejected.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";

export default {
  name: "social",
  data() {
    return {
      isModalReview:false,
      certificateName:"",
      idTraining:"",
      selectedRow:null,
      listTabMenu: [],
      inReview:[],
      bodyAdd: {
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        websiteProvider: "",
        contactPerson: "",
        email: "",
        phone: "",
        training: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "IDR",
        price: "",
        websiteTraining: "",
        description: ""
      },
      isScheduleModalVisible: false,
      isEnrollModalVisible: false,
      schedule: {
        date: null,
        startTime: null,
        endTime: null
      },
      scheduleList: [],
      bodyEnroll: {
        id: "",
        trainingTitle: "",
        trainingProvider: "",
        trainingMethod: "",
        price: "",
        location: ""
      },
      // originalTrainingMethod: "",
      // originalPrice: "",
      selectedParticipants: [],
      selectedLearning: null,
      searchTimeout: null,
      isModalVisible: false,
      dataTraining: [],
      dataProvider: [],
      dataCompetency: [],
      dataTrainingMethod: [],
      dataTrainingType: [],
      structuredLearning: [],
      selectedRow: null,
      selectedRows: [],
      approvedItems: [],
      rejectedItems: [],
      currencies: ["USD", "IDR"],
      selectedCurrency: "IDR",
      isLoading: true,
      isEmpty: false,
      currentTab: 0
    };
  },
  computed: {
    formattedParticipants() {
      return this.selectedRow && this.selectedRow.participants
        ? this.selectedRow.participants
        : [];
    }
  },
  watch: {
    selectedLearning(newVal) {
      if (newVal) {
        this.bodyAdd.training = newVal.id;
      } else {
        this.bodyAdd.training = null;
      }
    },
    "bodyAdd.provider": "fetchTrainingData"
  },
  methods: {
    getBadgeStatus(value) {
      if (!value) return "";
      const status = value.toLowerCase();

      if (status === "completed") {
        return "badge bg-success  align-items-center";
      } else if (status === "draft") {
        return "badge bg-warning text-dark  align-items-center";
      } else if (status === "registered") {
        return "badge bg-secondary  align-items-center";
      } else if (status === "rejected") {
        return "badge bg-danger  align-items-center";
      } else if (status === "submitted") {
        return "badge bg-success  align-items-center";
      } else if (status === "approved") {
        return "badge bg-success  align-items-center";
      } else if (status === "enrolled") {
        return "badge bg-success  align-items-center";
      } else if (status === "assigned") {
        return "badge bg-success  align-items-center";
      } else if (status === "in progress" || status === "in_progress") {
        return "badge bg-warning text-dark  align-items-center";
      } else if (status === "to do" || status === "to_do") {
        return "badge bg-danger  align-items-center";
      } else if (status === "active") {
        return "badge bg-success  align-items-center";
      } else if (status === "in review") {
        return "badge bg-info  align-items-center";
      } else if (status === "closed") {
        return "badge bg-secondary  align-items-center";
      } else if (status === "submit") {
        return "badge bg-success  align-items-center";
      } else if (status === "revision") {
        return "badge bg-danger  align-items-center";
      }else if (value === "scheduled") {
        return "badge bg-warning";
      }

      return "";
    },
    getIconClass(value) {
      if (!value) return "";
      const status = value.toLowerCase();
      switch (status) {
        case "completed":
          return "fe fe-check-circle";
        case "draft":
          return "fe fe-file-text";
        case "registered":
          return "fe fe-user-check";
        case "rejected":
          return "fe fe-x";
        case "submitted":
          return "fe fe-send";
        case "approved":
          return "fe fe-check";
        case "enrolled":
          return "fe fe-user-plus";
        case "assigned":
          return "fe fe-user-check";
        case "in progress":
        case "in_progress":
          return "fe fe-loader";
        case "to do":
        case "to_do":
          return "fe fe-list";
        case "active":
          return "fe fe-activity";
        case "in review":
          return "fe fe-eye";
        case "closed":
          return "fe fe-lock";
        case "submit":
          return "fe fe-arrow-up-circle";
        case "revision":
          return "fe fe-edit";
        case "scheduled":
          return "fe fe-calendar";
        default:
          return "";
      }
    },
     viewDetailsReview(item) {
      console.log("rownya", item);
      this.idTraining = item.idp_social_learning_id;
      this.selectedRow = item;
      // this.bodyEvent.trainingId = item.id;
      // this.preselectitems();
      this.certificateName = item.presentation_url;

      // this.updateCertificateUrl();
      // this.getEventByHr();
      this.isModalReview = true;
    },
     completeReview(item) {
      // console.log("isi review", item)
       // let idTraining = item.id
      let data={
        id:this.idTraining
      }
      this.$swal({
        title: "Selesaikan Coaching",
        text: "Apakah Anda yakin ingin menyelesaikan review coaching yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/completeReviewSocial", data)
            .then((response) => {
              this.$swal(
                "Selesai",
                "Coaching Anda telah direview.",
                "success"
              );
              this.getIdpReview();
              this.isModalReview = false;
            })
            .catch((error) => {
              this.$swal("Error", "Review gagal. Silakan coba lagi.", "error");
              console.error("Review failed:", error);
            });
        }
      });
    },
     getIdpReview() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getReviewSocial")
        .then((res) => {
          // console.log("isi res", res);
          this.inReview = res.data;

          this.isEmpty = !this.inReview || this.inReview.length === 0;
          // this.preselectRows();
          this.isLoading = false;
          // console.log("structured learning=> ", this.structuredLearning);
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },
    formatSchedule(scheduleList) {
      return scheduleList.map((item) => {
        const date = new Date(item.date);
        const formattedDate = date.toISOString().split("T")[0]; // Convert to YYYY-MM-DD format
        const formattedStartTime = `${item.startTime}:00+07`; // Append time and timezone
        const formattedEndTime = `${item.endTime}:00+07`; // Append time and timezone

        return {
          date: formattedDate,
          start_time: formattedStartTime,
          end_time: formattedEndTime
        };
      });
    },
    showScheduleModal() {
      this.isScheduleModalVisible = true;
    },
    clearScheduleModal() {
      this.schedule = { date: null, startTime: null, endTime: null };
    },
    addSchedule() {
      if (
        this.schedule.date &&
        this.schedule.startTime &&
        this.schedule.endTime
      ) {
        const formattedSchedule = {
          date: this.$moment(this.schedule.date).format("DD MMM YYYY"),
          startTime: this.$moment(this.schedule.startTime).format("HH:mm"),
          endTime: this.$moment(this.schedule.endTime).format("HH:mm")
        };
        this.scheduleList.push(formattedSchedule);
        this.clearScheduleModal();
        this.isScheduleModalVisible = false;
      } else {
        this.$swal("Lengkapi semua kolom");
      }
    },
    removeSchedule(index) {
      this.scheduleList.splice(index, 1);
    },
    updateSelectedParticipants(participants) {
      this.selectedParticipants = participants;
    },
    clearEnrollModal() {
      this.bodyEnroll.trainingTitle = "";
      this.bodyEnroll.trainingProvider = "";
      this.bodyEnroll.trainingMethod = "";
      this.bodyEnroll.location = "";
      this.bodyEnroll.price = "";
      this.bodyEnroll.schedule = [];
      this.bodyEnroll.checkedParticipants = [];
      this.selectedParticipants = [];
      this.scheduleList = [];
      this.selectedRows = [];
    },
    enrollEmployee() {
      // console.log("awikwok",this.selectedRow)
      this.bodyEnroll.id = this.selectedRow.id;
      this.selectedParticipants = this.selectedRow.participants.filter(
        (participant) => this.selectedRows.includes(participant.id)
      );
      this.bodyEnroll.trainingTitle = this.selectedRow.coaching_title;
      this.bodyEnroll.trainingProvider = this.selectedRow.training_provider;
      this.bodyEnroll.trainingMethod = this.selectedRow.training_method_id;
      this.bodyEnroll.price = this.selectedRow.training_price;
      this.isEnrollModalVisible = true;
    },
    submitEnroll() {
      // console.log("isi enroll id",this.bodyEnroll.id)
      // console.log("Original schedule list:", this.scheduleList);
      const formattedSchedule = this.formatSchedule(this.scheduleList);
      // console.log("Formatted schedule:", formattedSchedule);
      let requestData = {
        id: this.selectedParticipants.map(
          (participant) => participant.idp_social_learning_id
        ),
        coaching_id: this.bodyEnroll.id,
        // training_title: this.bodyEnroll.trainingTitle,
        // training_provider: this.bodyEnroll.trainingProvider,
        // training_method:this.bodyEnroll.trainingMethod,
        location: this.bodyEnroll.location,
        // price:Number(this.bodyEnroll.price),
        schedule: formattedSchedule,
        participants: this.selectedParticipants.map(
          (participant) => participant.nik
        )
      };

      // if (this.bodyEnroll.trainingMethod !== this.originalTrainingMethod) {
      //   requestData.training_method = this.bodyEnroll.trainingMethod;
      // }

      // if (this.bodyEnroll.price !== this.originalPrice) {
      //   requestData.training_price = this.bodyEnroll.price;
      // }

      // console.log("Payload yang dikirim", requestData);

      this.$store
        .dispatch("myIdp/enrollSocialLearning", requestData)
        .then((response) => {
          this.$swal(
            "Success",
            "Pendaftaran berhasil dikirim",
            "success"
          );
          this.isEnrollModalVisible = false;
          this.isModalVisible = false;
          this.clearEnrollModal();
          this.getData();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Pendaftaran belum berhasil dikirim: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    preselectRows() {
      this.selectedRows = this.selectedRow.participants
        .filter((item) => item.isl_status === "approved")
        .map((item) => item.id);
    },
    resetForm() {
      this.bodyAdd = {
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        website: "",
        contactPerson: "",
        email: "",
        phone: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "",
        price: "",
        description: ""
      };
      this.selectedLearning = null;
      this.$refs.modalTrainingAspiration.hide();
    },
    createTraining() {
      let requestData = {};

      if (this.bodyAdd.provider && this.selectedLearning) {
        requestData = {
          competency: this.bodyAdd.competency,
          provider: this.bodyAdd.provider,
          training: this.bodyAdd.training
        };
      } else if (this.bodyAdd.provider && !this.selectedLearning) {
        requestData = {
          competency: this.bodyAdd.competency,
          provider: this.bodyAdd.provider,
          training: {
            title: this.bodyAdd.trainingName,
            training_type: this.bodyAdd.learningType,
            training_method: this.bodyAdd.learningMethod,
            currency: this.bodyAdd.currency,
            price: this.bodyAdd.price,
            website: this.bodyAdd.websiteProvider,
            description: this.bodyAdd.description
          }
        };
      } else if (!this.bodyAdd.provider && !this.selectedLearning) {
        requestData = {
          competency: this.bodyAdd.competency,
          provider: {
            name: this.bodyAdd.providerName,
            address: this.bodyAdd.address,
            website: this.bodyAdd.websiteProvider,
            contact_person: this.bodyAdd.contactPerson,
            email: this.bodyAdd.email,
            phone: this.bodyAdd.phone
          },
          training: {
            title: this.bodyAdd.trainingName,
            training_type: this.bodyAdd.learningType,
            training_method: this.bodyAdd.learningMethod,
            currency: this.bodyAdd.currency,
            price: this.bodyAdd.price,
            website: this.bodyAdd.websiteTraining,
            description: this.bodyAdd.description
          }
        };
      }
      // console.log("req data => ",requestData)
      this.$store
        .dispatch("myIdp/createStructuredLearning", requestData)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "Aspirasi pelatihan berhasil dibuat."
            })
            .then(() => {
              // this.$refs.modalTrainingAspiration.hide();
              this.getData();

              this.resetForm();
            });
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan saat membuat aspirasi pelatihan."
          });
        });
    },

    selectTraining(training) {
      if (training) {
        this.bodyAdd.learningMethod = training.training_method;
        this.bodyAdd.learningType = training.training_type;
        this.bodyAdd.currency = training.currency;
        this.bodyAdd.price = training.price;
        this.bodyAdd.trainingName = training.title;
        this.bodyAdd.websiteTraining = training.website;
        this.bodyAdd.description = training.description || "";
      } else {
        this.bodyAdd.learningMethod = null;
        this.bodyAdd.learningType = null;
        this.bodyAdd.currency = "IDR";
        this.bodyAdd.price = null;
        this.bodyAdd.trainingName = "";
        this.bodyAdd.websiteTraining = "";
        this.bodyAdd.description = "";
      }
    },
    async fetchTrainingData(providerId) {
      if (providerId) {
        try {
          const args = {};
          await this.$store.dispatch("trainingProvider/getTrainingByProvider", {
            providerId,
            args
          });
          this.dataTraining =
            this.$store.state.trainingProvider.trainingByProvider;
        } catch (err) {
          console.error(err);
          this.dataTraining = [];
        }
      } else {
        this.dataTraining = [];
      }
    },
    async searchTraining(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(async () => {
        if (search.length >= 2 && this.bodyAdd.provider) {
          try {
            await this.$store.dispatch(
              "trainingProvider/getTrainingByProvider",
              {
                providerId: this.bodyAdd.provider,
                search
              }
            );
            this.dataTraining =
              this.$store.state.trainingProvider.trainingByProvider;
          } catch (err) {
            console.error(err);
            this.dataTraining = [];
          }
        } else {
          this.dataTraining = [];
        }
      }, 300);
    },
    selectProvider(selectedProviderId) {
      const selectedProvider = this.dataProvider.find(
        (provider) => provider.id === selectedProviderId
      );
      if (selectedProvider) {
        this.bodyAdd.providerName = selectedProvider.providerName;
        this.bodyAdd.address = selectedProvider.address;
        this.bodyAdd.websiteProvider = selectedProvider.website;
        this.bodyAdd.contactPerson = selectedProvider.contactPerson;
        this.bodyAdd.email = selectedProvider.email;
        this.bodyAdd.phone = selectedProvider.phone;
      }
    },
    viewDetails(row) {
      this.selectedRow = row;
      this.preselectRows();
      // console.log("isi selected row", this.selectedRow);
      this.isModalVisible = true;
    },
    clearSelectedRow() {
      this.selectedRow = null;
    },
    getProvider() {
      this.$store
        .dispatch("trainingProvider/getTrainingProviders")
        .then((res) => {
          // console.log("provid", res.data);
          this.dataProvider = res.data;
        });
    },
    getCompetency() {
      this.$store.dispatch("competency/getDataCompetencyByNik").then((res) => {
        // console.log("competen", res.data);
        this.dataCompetency = res.data;
      });
    },
    getTrainingMethod() {
      this.$store.dispatch("trainingMethod/getTrainingMethod").then((res) => {
        // console.log("trainMe", res.data);
        this.dataTrainingMethod = res.data;
      });
    },
    getTrainingType() {
      this.$store.dispatch("trainingType/getTrainingType").then((res) => {
        // console.log("trainType", res.data);
        this.dataTrainingType = res.data;
      });
    },
    getData() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpHrSocial")
        .then((res) => {
          // console.log("isi res", res);
          this.structuredLearning = res.data;

          this.isEmpty =
            !this.structuredLearning || this.structuredLearning.length === 0;
          // this.preselectRows();
          this.isLoading = false;
          // console.log("structured learning=> ", this.structuredLearning);
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    initStructuredLearning() {
      this.$store
        .dispatch("myIdp/initIdpStructuredLearning")
        .then((res) => {
          // console.log("isi res", res);
          this.getData();
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
        });
    },
    // getBadgeStatus(value) {
    //   if (value === "Completed") {
    //     return "badge bg-info";
    //   } else if (value === "Planning") {
    //     return "badge bg-warning";
    //   } else if (value === "Assigned") {
    //     return "badge bg-success";
    //   } else if (value === "Execution") {
    //     return "badge bg-danger";
    //   }
    // },
    getBadgeSummary(value) {
      if (value === "Completed") {
        return "badge bg-success";
      } else if (value === "In Progress") {
        return "badge bg-warning";
      }
    },
    getBadgeStatusStructured(value) {
      // const status = value.toLowerCase();
      if (value === "completed") {
        return "badge bg-info";
      } else if (value === "draft") {
        return "badge bg-warning";
      } else if (value === "registered") {
        return "badge bg-secondary";
      } else if (value === "rejected") {
        return "badge bg-danger";
      } else if (value === "submitted") {
        return "badge bg-success";
      } else if (value === "approved") {
        return "badge bg-success";
      } else if (value === "enrolled") {
        return "badge bg-success";
      }
      return "";
    },
    capitalizeStatus(value) {
      if (!value) {
        return null;
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(price);
    },
    enrollTraining() {
      this.$swal({
        title: "Daftar Pelatihan",
        text: "Apakah Anda yakin ingin mendaftar pelatihan yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/submitStructuredLearning", requestBody)
            .then((response) => {
              this.$swal(
                "Terdaftar",
                "Pelatihan Anda berhasil didaftarkan.",
                "success"
              );
              this.getData();
            })
            .catch((error) => {
              this.$swal(
                "Error",
                "Pengiriman gagal. Silakan coba lagi.",
                "error"
              );
              console.error("Submission failed:", error);
            });
        }
      });
    },
    confirmSubmission() {
      const approved = this.approvedItems.map((item) => item.id);
      const rejected = this.rejectedItems.map((item) => item.id);
      const cleanedSelectedRows = this.selectedRows.filter(
        (id) => typeof id === "number"
      );
      const reqBody = {
        id: approved,
        reject_id: rejected
      };
      this.$store
        .dispatch("myIdp/submitStructuredLearning", reqBody)
        .then((response) => {
          this.$swal(
            "Terkirim",
            "Pembelajaran Anda telah dikirim.",
            "success"
          );
          this.$refs.confirmationModal.hide();
          this.getData();
        });
    },
    submitLearning() {
      const ids = this.selectedRows.map((row) => row.id);
      const requestBody = { id: ids };
      const cleanedSelectedRows = this.selectedRows.filter(
        (id) => typeof id === "number"
      );
      this.approvedItems = this.structuredLearning.filter(
        (item) =>
          cleanedSelectedRows.includes(item.id) && item.status === "draft"
      );
      this.rejectedItems = this.structuredLearning.filter(
        (item) =>
          !cleanedSelectedRows.includes(item.id) && item.status === "draft"
      );
      this.$refs.confirmationModal.show();
    }
  },
  mounted() {
    // this.getData();
    this.getIdpReview()
    // this.getCompetency();
    // this.getProvider();
    // this.getTrainingMethod();
    // this.getTrainingType();
    const listMenu = JSON.parse(localStorage.getItem('listMenu') || [])
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find((menu) =>
      menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
    );
    this.listTabMenu = menu;
  }
};
</script>

<style>
.table-responsive::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Opera */
}
.table-responsive {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
